import { Separator } from '@/components/ui/separator'
import { Tooltip, TooltipTrigger } from '@/components/ui/tooltip'
import { Row } from '@tanstack/react-table'
import { Link } from 'react-router-dom'
import { billingHistoryItemSchema } from '../_data/billing-history-definition'
interface DataTableRowActionsProps<TData> {
  row: Row<TData>
}

const DownloadIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.6">
        <path
          d="M8 17V15H16V17H8ZM16 10L12 14L8 10H10.5V7H13.5V10H16ZM5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V19C21 20.11 20.11 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 3.9 3.9 3 5 3ZM5 5V19H19V5H5Z"
          fill="black"
        />
      </g>
    </svg>
  )
}

const ViewDetailIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.6">
        <path
          d="M21.544 11.045C21.848 11.471 22 11.685 22 12C22 12.316 21.848 12.529 21.544 12.955C20.178 14.871 16.689 19 12 19C7.31 19 3.822 14.87 2.456 12.955C2.152 12.529 2 12.315 2 12C2 11.684 2.152 11.471 2.456 11.045C3.822 9.129 7.311 5 12 5C16.69 5 20.178 9.13 21.544 11.045Z"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 12C15 11.2044 14.6839 10.4413 14.1213 9.87868C13.5587 9.31607 12.7956 9 12 9C11.2044 9 10.4413 9.31607 9.87868 9.87868C9.31607 10.4413 9 11.2044 9 12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12Z"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}
export function BillingHistoryTableAction<TData>({
  row,
}: DataTableRowActionsProps<TData>) {
  const values = billingHistoryItemSchema.parse(row.original)

  return (
    <div className="flex item-center justify-center">
      <div className="flex flex-row items-center border border-[#D5D5D5] rounded-lg h-8 justify-between">
        <div className="flex-1 w-[48px]">
          <Link
            target="_blank"
            to={values.viewUrl}
            className={
              'flex items-center cursor-pointer justify-center w-full px-2 !py-0'
            }
          >
            <ViewDetailIcon />
          </Link>
        </div>
        <Separator
          orientation="vertical"
          className="h-8 w-[0.6px] bg-[#D5D5D5]"
        />
        <div className="flex-1 w-[48px] ">
          <Link
            target="_blank"
            to={values.downloadPdf}
            className={
              'flex items-center cursor-pointer justify-center w-full px-2 !py-0'
            }
          >
            <DownloadIcon />
          </Link>
        </div>
      </div>
    </div>
  )
}
